export const agentConsoleConsumption =
  "/analytics_dashboard/:app_group_id/agent_console_credit_consumption_detail_data";
